import React, {Component} from "react";
import {
    Badge,
    Row,
    Col,
    Modal,
    ModalBody,
    InputGroup,
    Jumbotron,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Button,
    ButtonToolbar,
    ButtonGroup,
    ButtonDropdown,
    Label,
    FormGroup,
    Input,
    Alert,
    Table
} from "reactstrap";
import LoadingIndicator from '../../utils/LoadingIndicator';
import {ajaxWrapperGet, ajaxWrapperPost} from "../../utils/deviceAPI";
import NotificationHOC from "../../components/Notifications/NotificationHOC";
import moment from 'moment';



class Accountinvitations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            inviteUserEmail: "",
            inviteUserEmailValid: false,
            inviteUserEmailMessage: "",
            inviteUserFormValid: false,
            modalDeleteInvite: false,
            currentUserBeingEdited: 0,
            currentUserBeingEditedEmail: ""
        };
        this.handleChange = this.handleChange.bind(this);
        this.inviteNewUserAccount = this.inviteNewUserAccount.bind(this);
        this.formDefaults = this.formDefaults.bind(this);
        this.toggleDelete = this.toggleDelete.bind(this);
        this.deleteInvite = this.deleteInvite.bind(this);
    }
    componentDidMount() {
        this.setData();
    }
    toggleDelete() {
        this.setState({
            modalDeleteInvite: !this.state.modalDeleteInvite
        });
    }
    setData() {
        ajaxWrapperGet('/api/user/accountInvites').then((data) => {
            this.setState({
                data,
                loading: false
            });

        });
    }
    userBeingEdited(id = 0, email = "") {
        this.setState({
            currentUserBeingEdited: id,
            currentUserBeingEditedEmail: email
        });
    }
    handleChange({ target }) {
        const name = target.name;
        const value = target.value;
        this.setState({
                [name]: value
            },
            () => { this.validateField(name, value) }

        );
    }

    validateField(fieldName, value) {
        let _emailValid = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
        let _inviteUserEmailValid = this.state.inviteUserEmailValid;
        let _inviteUserEmailMessage = this.state.inviteUserEmailMessage;

        switch(fieldName) {
            case 'inviteUserEmail':
                if (!_emailValid.test(value)) {
                    _inviteUserEmailValid = false;
                    _inviteUserEmailMessage = "Invalid Email";
                }
                else {
                    _inviteUserEmailValid = true;
                    _inviteUserEmailMessage = "";

                }
                break;
        }
        this.setState({
            inviteUserEmailValid:_inviteUserEmailValid,
            inviteUserEmailMessage:_inviteUserEmailMessage,
            inviteUserFormValid: _inviteUserEmailValid

        });
    }

    inviteNewUserAccount() {
        let postData = {
            email:this.state.inviteUserEmail
        };
        ajaxWrapperPost(`/api/user/sendAccountInvite`,postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message,'success');
                this.formDefaults();
                this.setData();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message,'error');
            }
        });

    }

    deleteInvite() {
        let postData = {
            id: this.state.currentUserBeingEdited,
            email: this.state.currentUserBeingEditedEmail
        };
        ajaxWrapperPost('/api/user/deleteAccountInvite',postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message,'success');
                this.toggleDelete();
                this.setData();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message,'error');
            }
        });
    }

    formDefaults() {
        this.setState({
            inviteUserEmail: "",
            inviteUserEmailValid: false,
            inviteUserEmailMessage: "",
            inviteUserFormValid: false
        });
    }

    render() {
        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        return (
            <div className="animated fadeIn">
                <NotificationHOC ref="notification"/>
                <Row className="wide-overflow bg-sendInvites">
                    <Col xs="12">
                        <Jumbotron className="bg-none">
                            <Row>
                                <Col sm="12">
                                    <p className="lead"><strong>Invite a new user to the system.</strong></p>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <hr className="mb-4 hr-white"/>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <p>Send an invite to the user by typing their email address below.</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <FormGroup row>
                                        <Col xs="12" md="9">
                                            <InputGroup className="mb-3">
                                                <div className="input-group-prepend">
                                                <span className={`input-group-text input-nobg ${this.state.inviteUserEmailValid ? "gl-append-is-valid" : "gl-append-is-invalid"}`}>
                                                    <i className="fa fa-envelope-o"> </i>
                                                </span>
                                                </div>
                                            <Input type="email" id="addNewUseremail" name="inviteUserEmail" className={`input-nobg gl-lineheighttwo ${this.state.inviteUserEmailValid ? "is-valid" : "is-invalid"}`} placeholder="Enter User's Email" value={ this.state.inviteUserEmail } onChange={ this.handleChange } required/>
                                            {this.state.inviteUserEmailMessage.length <= 0 ? "" :
                                                <div className="invalid-feedback" id="passwordError" >{this.state.inviteUserEmailMessage}</div>
                                            }
                                            </InputGroup>
                                        </Col>
                                        <Col xs="12" md="3">
                                            <Button color={this.state.inviteUserEmailValid ? "success" : "danger"} onClick={this.inviteNewUserAccount} className="btn btn-block gl-lineheighttwo" disabled={!this.state.inviteUserFormValid}>
                                                Send Invite
                                            </Button>
                                        </Col>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <p>Instructions for registering with the system will be sent out to the user. Once the user is registered, you will need to send the user a <a href="#/invitations/site">Site Invite</a></p>
                                </Col>
                            </Row>
                        </Jumbotron>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardBody className="card-body">
                                <Row className="pb-4">
                                    <Col sm="12">
                                        <CardTitle className="mb-1">Pending Account Invites Sent</CardTitle>
                                        <div className="small text-muted">list of current site pending invites sent to other users</div>
                                    </Col>
                                </Row>
                                <Row className="pb-2">
                                    <Col xs="12" sm="12" lg="12" xl="12" className="mb-1">
                                        <ul className="icons-list mb-5 list-inline">
                                            {this.state.data.pendingInvites.map((invite,index) => {
                                                    return (
                                                        <li key={index} className="mb-3 mt-3 listSiteItems">
                                                            <i className={"fa fa-arrow-circle-right"}></i>
                                                            <div className="desc-n">
                                                                <div className="title">{invite.email}</div>
                                                                <div className="small text-muted text-lowercase pb-3">invitation sent {moment(invite.invitationDateTime).format('MM/DD/YY - hh:mm:ss A')}</div>
                                                            </div>
                                                            <div className="actions">
                                                                <Button color="link" className="text-danger" onClick={() => {this.toggleDelete(); this.userBeingEdited(invite.id,invite.email);}}><i className="fa fa-trash"></i></Button>
                                                            </div>
                                                        </li>
                                                    );
                                                }
                                            )}
                                            {this.state.data.pendingInvites.length === 0 ? <Alert color="secondary" ><small>You currently don't have any sent account invites.</small></Alert>:""}
                                        </ul>
                                    </Col>
                                </Row>
                                <Modal isOpen={this.state.modalDeleteInvite} toggle={this.toggleDelete} >

                                    <ModalBody>
                                        <Row>
                                            <Col sm="10">
                                                <CardTitle className="mb-1">Delete Invite</CardTitle>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="12">
                                                <hr className="mb-4"/>
                                            </Col>
                                        </Row>
                                        <Row className="pb-2">
                                            <Col sm="12">
                                                <div className="text-center">Are you sure you want to delete the pending invite for {this.state.currentUserBeingEditedEmail} ?</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="12">
                                                <hr className="mb-4"/>
                                            </Col>
                                        </Row>
                                        <Row className="pb-4">
                                            <Col sm="6" className="small text-muted">
                                                <Button color="link" className="btn btn-block" onClick={this.toggleDelete}>Cancel</Button>
                                            </Col>
                                            <Col sm="6" className="small text-muted">
                                                <Button color="danger" className="btn btn-block" onClick={this.deleteInvite} >Delete</Button>
                                            </Col>
                                        </Row>
                                    </ModalBody>
                                </Modal>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default Accountinvitations;



// WEBPACK FOOTER //
// ./src/views/Invitations/Accountinvitations.js